import React from 'react'
import { ForwardRefExoticComponent, SVGProps } from 'react'

import { Link } from '@factorialco/f0-react/icons/app'
import { FormsElementTypeEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import UrlElementQuestion from 'modules/forms/components/QuestionComponent/UrlElementQuestion'
import { Element } from 'modules/forms/lib/Element'
import { Answer, Options } from 'modules/forms/lib/types'

/**
 * UrlElement class for url input elements.
 * Extends the base Element class.
 */
export class UrlElement extends Element {
  static create({ label, options = {} }: { label: string; options: Options }): UrlElement {
    const el = new UrlElement({
      label,
      description: options.description,
      mandatory: options.mandatory || options.locked, //locked element are always mandatory
    })
    if (options.locked) {
      el.lock()
    }

    return el
  }
  /**
   * Get the name of the element
   */
  getName(): string {
    return i18n.t('forms.modals.elements.url')
  }

  /**
   * Get the type of the element
   */
  getType(): FormsElementTypeEnum {
    return 'url'
  }

  /**
   * Get the icon for the element
   */
  getIcon(): ForwardRefExoticComponent<SVGProps<SVGSVGElement>> {
    return Link
  }

  getPreviewComponent(disabled?: boolean): React.ReactNode {
    return <UrlElementQuestion element={this} disabled={disabled} />
  }

  getQuestionComponent(onChange: (answer: Answer) => void): React.ReactNode {
    return <UrlElementQuestion element={this} onChange={onChange} />
  }
}
